import {
  CHANGE_QUERY
} from './../search/actions';

export let query = function (state = {
  query: '',
  filters: {}
}, action) {
  switch (action.type) {
    case CHANGE_QUERY:
      return Object.assign({}, action.query);
  }
  return state;
};



/** WEBPACK FOOTER **
 ** ./src/modules/ui/reducers.js
 **/